// @flow
export {
  captureException,
  captureMessage,
  configureScope,
  showReportDialog,
  withScope,
} from '@sentry/browser';



// WEBPACK FOOTER //
// ../utilities/sentry.client.js